import React from 'react';
import classnames from 'classnames';

import { isGreaterThanBreakpoint } from 'dpl/util/grid';
import SmartImage from 'dpl/components/SmartImage';

import goodDogFoundersJpg from 'dpl/assets/reviews/good_dog_founders.jpg';

const ARTICLES = [
  {
    siteTitle: 'NEWS WEEK',
    articleTitle:
      'Good Dog aims to connect people with the breed that best suits them',
    url: 'https://www.newsweek.com/best-dog-breeds-mental-health-emotional-support-1439450'
  },
  {
    siteTitle: 'BUSTLE',
    articleTitle:
      'Good Dog helps owners find sources for new pets that are healthy, humane, and trusted among the community.',
    url: 'https://www.bustle.com/p/good-dog-a-new-site-for-adoptable-dogs-prioritizes-dogs-safety-in-the-process-17005583'
  },
  {
    siteTitle: 'YAHOO FINANCE',
    articleTitle:
      'These entrepreneurs recognized a gap in the wonderful world of dogs - and filled it',
    url: 'https://finance.yahoo.com/video/entrepreneurs-recognized-gap-wonderful-world-193536647.html'
  }
];

const bloombergArticle =
  'https://www.bloomberg.com/news/articles/2019-05-03/adopting-a-dog-good-dog-site-vets-breeders-to-avoid-puppy-mills';

const isGtSm = isGreaterThanBreakpoint('sm');

const siteTitleClassName = 'secondary font-12 fw-medium';

export default function NewsModule() {
  return (
    <div className="NewsModule container-xxl pt6 pt20-md pb6 pb18-md">
      <h4 className="font-24 md:font-32 pb6 pb8-md">Good Dog in the news</h4>
      <div className="NewsModule__grid">
        <div className="bt pt3 pt12-md pr12-md">
          <div className="grid grid-cols-1 md:grid-cols-2 md:gap-24">
            <div className="aspect-ratio aspect-ratio--1x1 mb4 mb0-md overflow-hidden">
              <div className="aspect-ratio--object">
                <SmartImage
                  Tag="div"
                  className="bg-center cover w-100 h-100"
                  src={goodDogFoundersJpg}
                  alt="Good Dog Founders"
                />
              </div>
            </div>
            <div>
              <a href={bloombergArticle} target="_blank" rel="noreferrer">
                <p className={classnames('mb2 mb6-md', siteTitleClassName)}>
                  BLOOMBERG
                </p>
                <p className="font-serif font-20 md:font-24 mb2 mb3-md">
                  Adopt or shop: this dog startup says you don’t have to choose
                </p>
                <p className="secondary font-16 mb6">
                  The pet adoption market looks cute from the outside—cuddly
                  mutts looking for homes, eager parents seeking a new family
                  member. But there’s a darker side to it: so-called “puppy
                  mills” [ . . . ] Good Dog can help ensure that buyers are only
                  choosing from upstanding ones.
                </p>
              </a>
            </div>
          </div>
        </div>
        <div className="bt pt0 pt12-md">
          {isGtSm && <p className="fw-medium font-16">About Good Dog</p>}
          {ARTICLES.map((article, idx) => (
            <div
              key={article.siteTitle}
              className={classnames('pv6', {
                'bb b--hairline': idx !== ARTICLES.length - 1
              })}
            >
              <a href={article.url} target="_blank" rel="noreferrer">
                <p className={classnames('mb3', siteTitleClassName)}>
                  {article.siteTitle}
                </p>
                <p className="font-serif fw-medium font-18 md:font-20">
                  {article.articleTitle}
                </p>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
